import Splide from '@splidejs/splide'

document.addEventListener('DOMContentLoaded', function (e) {
    const profilesBlockSlider = e.target.querySelector('.js-profiles-slider')

    if (profilesBlockSlider) {
        const profilesSplideInstance = new Splide('.js-profiles-slider', {
            arrows: false,
            perMove : 1,
            perPage: 1,
            padding: { right: '45%' },
            gap: '22px',
            breakpoints: {
                991: {
                    perPage: 2,
                    gap: '10px',
                    padding: { right: '10%' },
                    pagination: false,
                },
                719: {
                    perPage: 1,
                    padding: { right: '0%' },
                }
            }
        })

        profilesSplideInstance.mount()

        const profileIcon = e.target.querySelector('.container__icon')
        profileIcon.addEventListener('click', () => {
            profilesSplideInstance.go(profilesSplideInstance.index + 1)
        })
    }
})
